<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
        <div class="page-header-top-container">
            <div class="page-name">Top Facility Export</div>
        </div>
        <!--page content-->
        <div class="admin-page-content">
            <form id="importTasksform" enctype="multipart/form-data">
            <div class="form-row">
                <div class="col-md-6 form-group">
                    <label> Select CSV/Excel File to Import Top Facility Export Data:</label>
                    <div>
                        <input style="display: none;" type="file" name="excl_file" accept=".xlsx,.xls,.csv" id="topFacilityExportUpload" ref="fileTopFacilityExportData" v-on:change="handleFilesUploadCall()"/>
                        <label class="btn btn-secondary mb-0" for="topFacilityExportUpload"><i class="fa fa-upload mr-3" aria-hidden="true"></i>Upload File ...</label>
                        <button type="button" v-on:click="importData" class="btn btn-primary">Import</button>
                    </div>
                </div>
            </div>
            </form>
        </div>
        <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
import Vue from "vue";
import Footer from "@/components/partials/Footer";
import {commonMixins} from '../../mixins/commonMixins';
import EventBus from ".././event-bus";
import {importTopFacilityExport} from '../../config'
import axios from 'axios'

Vue.component("app-footer", Footer);

var self = '';

export default {
    name: 'TopFacilityExport',
    mixins: [commonMixins],
    data() {
        return {
                top_facility_export_data:[],
                filesData: [],
        }
    },
    created: function () {
    },
    beforeMount: function () {
        self = this;
    },
    mounted: function () {
        self.checkLocalStorage();
        self.setActiveMenu('top-facility-export');
        EventBus.$emit("menu-selection-changed", "top-facility-export");
    },
    methods: {
        checkLocalStorage : function () {       
            if(localStorage.getItem('user_obj')) {
                var userObj = localStorage.getItem('user_obj');
                if (userObj != null && userObj !== "") {
                    /* self.$router.push('/dashboard');
                    self.showHeader = true;
                    alert("Hello"); */
                } else {
                    // self.$router.push('/');
                    window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                }
            } else {
                // self.$router.push('/');
                window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
            }
        },
        handleFilesUploadCall: function () {
            if(self.$refs.fileTopFacilityExportData.files.length > 0) {
                self.filesData = self.$refs.fileTopFacilityExportData.files;
                let allowedextentions = /(\.xls|\.xlsx|\.csv)$/i;
                if (!allowedextentions.exec(self.filesData[0].name)) {
                    alert("Please select valid file!");
                    //self.filesData="";
                    self.$refs.fileTopFacilityExportData.value = '';
                }
            }
        },
        importData() {
            if(self.filesData) {
                if(self.filesData.length>0) {
                    $(".loading-container").show();
                    let file = self.filesData[0];
                    var formData = new FormData();
                    formData.append('top_facility_export', file, file.name);
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Content-Type": "multipart/form-data",
                                },
                    };
                    // formData.append('access_token', window.localStorage.getItem('api_token'));
                    axios.post(importTopFacilityExport, formData, config)
                            .then(function (response) {
                            self.$refs.fileTopFacilityExportData.value = '';
                            if(response.data.code=='204') {
                                setTimeout(function() { $(".loading-container").hide(); },1000);
                                alert(response.data.content);
                            } else if (response.data.code == '200') {
                                alert(response.data.content);
                            } else {
                                console.log("fail");
                                self.top_facility_export_data=[];
                            }
                            setTimeout(function() { $(".loading-container").hide(); },2000);
                            // $(".loading-container").hide();
                    })
                    .catch(function (err) {
                        self.$refs.fileTopFacilityExportData.value = '';
                        self.top_facility_export_data=[];
                        // $(".loading-container").hide();
                        setTimeout(function() { $(".loading-container").hide(); },2000);
                    });
                } else {
                    alert("Please select file to import.");
                }
            } else {
                alert("Please select file to import.");
            }
            //$(".loading-container").hide();
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/TopFacilityExport/TopFacilityExport.vue